//
//
//
//
//
//
//
//
//
//
//
//
//

import AppHeader from '~/components/AppHeader.vue';
import BottomNavigation from '~/components/BottomNavigation.vue';
import TopBar from '~/components/TopBar.vue';
import CartSidebar from '~/components/CartSidebar.vue';
import LoginModal from '~/components/LoginModal.vue';

export default {
  name: 'AccountLayout',

  components: {
    TopBar,
    AppHeader,
    BottomNavigation,
    CartSidebar,
    LoginModal
  },
  setup(p, context) {
    const { root: { $i18n, $options: { $xreq } } } = context;
    $i18n.__baseUrl = 'https://' + $xreq.host;
  }
};
